import React from 'react'
import {Spin} from 'antd'

function Spinner () {
  return <div style={{textAlign: 'center', marginTop: 300}}><Spin /></div>
}
export default Spinner
